import React from 'react';
import useStyle from './bottomMenu.style';
import { NavLink } from '../../../molecules/Links/NavLink';
import pages, { Page } from '../../../../routes/pages';
import CartButton from 'components/atoms/Buttons/CartButton';

export interface BottomMenuViewProps {
  pagesProps: Page[];
}

export const BottomMenuView = ({ pagesProps }: BottomMenuViewProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {pagesProps &&
        pagesProps.map((page, index) =>
          page.path === pages.PANIER_PAGE.path ? (
            <CartButton key={index} />
          ) : (
            <NavLink
              key={index}
              linkName={page.linkName}
              link={page.path}
              isExternal={false}
              isOnBottomMenu={true}
              icon={page.icon}
            />
          )
        )}
    </div>
  );
};
